import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FaPen,
  FaTrash,
  FaChevronDown,
  FaRegCalendarAlt,
  FaUser,
  FaList,
  FaRedo,
  FaSeedling,
} from "react-icons/fa";
import { IoIosApps } from "react-icons/io";
import { DeleteModal } from "../Fields/FieldDetails";
import { UserContext } from "../../UserContext";
import axios from "axios";
import "./Tasks.css";
import toast from "react-hot-toast"; // Add this line

const CustomStatusDropdown = ({ currentStatus, onStatusChange }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const statuses = [
    { key: "notStarted", label: "لم تبدأ" },
    { key: "inProgress", label: "جاري التنفيذ" },
    { key: "finished", label: "انتهت" },
  ];

  const selectedStatus =
    statuses.find((s) => s.key === currentStatus) || statuses[0];

  const handleSelect = (statusKey) => {
    onStatusChange(statusKey);
    setIsOpen(false);
  };

  return (
    <div className="task-status-wrapper">
      <button
        className={`task-status-badge status-${currentStatus}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {t(selectedStatus.label)}
        <FaChevronDown className="task-status-icon" />
      </button>
      {isOpen && (
        <div className="task-status-menu">
          {statuses.map((status) => (
            <div
              key={status.key}
              className="task-status-item"
              onClick={() => handleSelect(status.key)}
            >
              <span className={`status-label-badge status-item-${status.key}`}>
                {t(status.label)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const TaskDetails = () => {
  const { t, i18n } = useTranslation();
  const { fieldId, taskId } = useParams();
  const navigate = useNavigate();
  const { token, userData } = useContext(UserContext);
  const [task, setTask] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  useEffect(() => {
    const fetchTask = async () => {
      if (!taskId || !token) return;
      try {
        const response = await axios.get(`api/task/${taskId}`, {
          headers: { Authorization: token },
        });
        setTask(response.data.items[0]);
      } catch (error) {
        console.error("Failed to fetch task details:", error);
        toast.error(t("Could not load task details."));
        navigate(-1);
      }
    };
    fetchTask();
  }, [taskId, token, navigate, t]);

  console.log("task data from task details: ", task);
  // const handleStatusChange = async (newStatus) => {
  //   const originalFullTaskState = { ...task };

  //   // Optimistically update the UI
  //   setTask((prevTask) => ({
  //     ...prevTask,
  //     task: { ...prevTask.task, state: newStatus },
  //   }));

  //   try {
  //     // Construct the comprehensive payload
  //     const taskPayload = {
  //       // --- All fields from before ---
  //       id: task.task.id,
  //       name: task.task.name,
  //       textDesc: task.task.textDesc,
  //       taskCategoryId: task.task.taskCategoryId,
  //       farmId: task.task.farmId,
  //       tenantId: task.task.tenantId,
  //       fromDate: task.task.fromDate,
  //       isRecurring: task.task.isRecurring,
  //       state: newStatus,
  //       recurrencePattern: task.task.recurrencePattern,
  //       recurrenceDays: task.task.recurrenceDays,
  //       taskListId: task.task.taskListId,
  //       fieldId: task.task.fieldId,
  //       employeeId: task.task.employeeId,
  //       toDate: task.task.toDate,
  //       executeDate: task.task.executeDate,
  //       spanId: task.task.spanId,
  //       batchId: task.task.batchId,
  //       assigneeIds: task.task.assigneeIds,

  //       // --- FIX: Provide defaults for conflict check fields ---
  //       // The backend requires a non-null startTime for its conflict check.
  //       // We default to the task's fromDate if startTime is null.
  //       startTime: task.task.startTime || task.task.fromDate,

  //       // The conflict check also uses estimatedDuration, so we'll provide a
  //       // default of 0 if it's null to prevent potential errors.
  //       estimatedDuration: task.task.estimatedDuration || 0,
  //     };

  //     const formData = new FormData();
  //     formData.append("task", JSON.stringify(taskPayload));

  //     await axios.put("api/task/updateTaskWithAudioAndImages", formData, {
  //       headers: {
  //         Authorization: token,
  //       },
  //     });

  //     // On success, navigate back with a refresh signal.
  //     navigate(`/fields/${fieldId}`, { state: { refresh: true } });
  //   } catch (error) {
  //     console.error("Failed to update status:", error);
  //     if (error.response) {
  //       console.error("Error data:", error.response.data);
  //       alert(
  //         t(
  //           error.response.data.message ||
  //             "Failed to update status. Reverting change."
  //         )
  //       );
  //     } else {
  //       alert(t("Failed to update status. Reverting change."));
  //     }
  //     // Revert the UI change if the API call fails
  //     setTask(originalFullTaskState);
  //   }
  // };
  console.log("token;", token);
  const handleStatusChange = async (newStatus) => {
    const originalFullTaskState = { ...task };

    // Optimistically update the UI
    setTask((prevTask) => ({
      ...prevTask,
      task: { ...prevTask.task, state: newStatus },
    }));

    try {
      // Check user role to determine which API to use (same as Android logic)
      // roleId 1 = Manager, roleId 8 = Supervisor (can update the whole task)
      // Other roles = Workers (can only update their own assignment)
      const userRoleId = userData?.EmployeeRoles?.[0]?.roleId;
      const isManagerOrSupervisor = userRoleId === 1 || userRoleId === 8;

      if (isManagerOrSupervisor) {
        // Manager or supervisor - use the lightweight state update endpoint
        await axios.put(
          `api/task/${task.task.id}/state`,
          { state: newStatus },
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        // Worker - only update their own assignment status (like Android's updateTaskAssignee)
        const currentEmployeeId = userData?.Employee?.id;

        // Find the assignment for the current user (same as Android loop through assignments)
        const userAssignment = task.assignments?.find(
          (a) => a.employeeId === currentEmployeeId
        );

        if (!userAssignment) {
          throw new Error(t("You are not assigned to this task"));
        }

        // Update only the worker's assignment status using the assignment endpoint
        const assignmentPayload = {
          status: newStatus,
          actualTimeSpent: 0, // Same as Android passes 0 for actualTimeSpent
        };

        await axios.put(
          `api/task/assignment/${userAssignment.assignmentId}`,
          assignmentPayload,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );
      }

      toast.success(t("Task status updated successfully!"));
    } catch (error) {
      console.error("Failed to update status:", error);
      if (error.response) {
        console.error("Error data:", error.response.data);
        toast.error(
          error.message || t("Failed to update status. Reverting change.")
        );
      } else {
        toast.error(t("Failed to update status. Reverting change."));
      }
      // Revert the UI change if the API call fails
      setTask(originalFullTaskState);
    }
  };

  const handleDelete = async () => {
    try {
      // This endpoint is correct according to the documentation.
      await axios.delete(`api/task/${taskId}`, {
        headers: { Authorization: token },
      });
      toast.success(`${t("Task")} "${task.task?.name}" ${t("deleted")}.`);
      setDeleteModalOpen(false);
      navigate(`/fields/${fieldId}`);
    } catch (error) {
      console.error("Failed to delete task:", error);
      toast.error(t("Failed to delete task."));
    }
  };

  if (!task || !task.task) return <div>{t("Loading...")}</div>;

  const taskName = task.task?.name || t("Unnamed Task");
  const imageUrls = task.task?.imagesUrls
    ? task.task.imagesUrls.split(",").filter((url) => url)
    : [];

  return (
    <>
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDelete}
        itemName={taskName}
      />
      <div className="task-details-page">
        <header className="task-details-main-header">
          <h1 className="header-title">{t("Task Details")}</h1>
          <div className="header-actions">
            <button
              className="button-edit"
              onClick={() =>
                navigate(`/fields/${fieldId}/tasks/${taskId}/edit`)
              }
            >
              <FaPen /> {t("Edit Task")}
            </button>
            <button
              className="button-danger-outline"
              onClick={() => setDeleteModalOpen(true)}
            >
              <FaTrash /> {t("Delete Task")}
            </button>
          </div>
        </header>

        <div className="task-details-card">
          <div className="task-details-sub-header">
            <h2>{taskName}</h2>
            <CustomStatusDropdown
              currentStatus={task.task.state}
              onStatusChange={handleStatusChange}
            />
          </div>

          <div className="task-details-main-grid">
            <div className="task-details-item">
              <span className="task-details-label">
                <FaRegCalendarAlt /> {t("Date")}
              </span>
              <span className="task-details-value">
                {new Date(task.task.fromDate).toLocaleDateString()}
              </span>
            </div>

            {task.taskCategory && (
              <div className="task-details-item">
                <span className="task-details-label">
                  <FaSeedling /> {t("Task Type")}
                </span>
                <span className="task-details-value">
                  {i18n.language === "ar"
                    ? task.taskCategory.nameAr
                    : task.taskCategory.nameEn}
                </span>
              </div>
            )}

            {task.field && (
              <div className="task-details-item">
                <span className="task-details-label">
                  <IoIosApps /> {t("Field")}
                </span>
                <span className="task-details-value">{task.field.name}</span>
              </div>
            )}

            <div className="task-details-item">
              <span className="task-details-label">
                <FaUser /> {t("Assigned To")}
              </span>
              <span className="task-details-value">
                {task.assignments[0]?.employeeName || t("Unassigned")}
              </span>
            </div>

            {task.task.isRecurring && task.task.recurrencePattern && (
              <div className="task-details-item">
                <span className="task-details-label">
                  <FaRedo /> {t("Recurring Task")}
                </span>
                <span className="task-details-value">
                  {t(task.task.recurrencePattern)}
                </span>
              </div>
            )}

            {task.taskList?.name && (
              <div className="task-details-item">
                <span className="task-details-label">
                  <FaList /> {t("Task List")}
                </span>
                <span className="task-details-value">{task.taskList.name}</span>
              </div>
            )}
          </div>

          <div className="task-details-secondary-grid">
            {task.task.textDesc && (
              <div className="task-details-item full-width">
                <span className="task-details-label">{t("Description")}</span>
                <p className="task-details-value desc-text">
                  {task.task.textDesc}
                </p>
              </div>
            )}

            {imageUrls.length > 0 && (
              <div className="task-details-item full-width">
                <span className="task-details-label">{t("Photos")}</span>
                <div className="task-photo-gallery">
                  {imageUrls.map((url, index) => (
                    <img
                      key={index}
                      src={url}
                      alt={`${t("task attachment")} ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            )}

            {task.task.audioDesc && (
              <div className="task-details-item full-width">
                <span className="task-details-label">{t("Voice Note")}</span>
                <audio
                  src={task.task.audioDesc}
                  controls
                  className="task-audio-player"
                ></audio>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TaskDetails;
